import Page from './page-view'
import LoginPage from './page-login-view'
export { default as PageHeader } from './page-header-view'

export default Page
export { LoginPage }
